import AppDb        from '../database/database';
import events       from '../const/events';
import debug        from 'debug';
import AppState from './../state/app';
import EventEmitter from './eventEmitter';

const log = debug('ro:db-manger');

/**
 * @singleton
 */
class DataManager extends EventEmitter {
    constructor() {
        super();
        this.databases = {};
        this.syncing   = false;
    }

    registerDatabase(dbInstance) {
        this.databases[dbInstance.name] = dbInstance
    }

    async sync() {
        if (!AppState.state.online) {
            log('Db sync interrupted. App in offlien mode');
            return;
        }
        this.syncing = true;
        log(`Syncong databases: ${Object.keys(this.databases).join(',')}`);
        this.emit(events.DATABASES.SYNC_START, {});
        let queue = Promise.resolve();
        Object.keys(this.databases).map((dbName) => {
            queue = queue.then(() => {
                this.emit(events.DATABASE.SYNC_START, dbName);
                return this.databases[dbName].sync()
            })
            .then(() => {
                log(`Db ${dbName} ready`)
                this.emit(events.DATABASE.SYNC_COMPLETE, dbName);
            })
        })
        queue = queue.then(() => {
            this.emit(events.DATABASES.SYNC_COMPLETE, {});
            this.syncing = false;
        })
        return queue;
    }
}

let manager = new DataManager();
manager.registerDatabase(new AppDb());

export default manager;


// WEBPACK FOOTER //
// ./src/core/dataManager.js